import React from 'react';
import './consulta-estado.css';

const ConsultaEstado = (props) => {

  return (
    <div className='panel panel-default buscador sin-paquetes p-4 mb-5 bg-white'>
      {props.children}
    </div>
  );
};

export default ConsultaEstado;
